var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import Svg from './Svg';
/**
 * ATTENTION! This helper function should be used only for the main svg icons from the design system.
 * For the Status icons or any other icons this helper should not be used.
 */
export var createSvg = function (Path, displayName, viewBox) {
    if (viewBox === void 0) { viewBox = '0 0 24 24'; }
    var SvgComponent = function (props) {
        var strokeWidth = undefined;
        // https://www.figma.com/file/JDBBmBjcGVaUykMiVhgK4X/%F0%9F%8D%ADIcons?node-id=2-82&t=tjwZqrMwlDXW4Ylc-0
        if (props && 'size' in props && props.size) {
            strokeWidth = props.size <= 16 ? 2.2 : props.size <= 20 ? 2 : 1.5;
        }
        return (<Svg {...props} id={displayName} viewBox={viewBox}>
                <Path strokeWidth={strokeWidth}/>
            </Svg>);
    };
    SvgComponent.displayName = "Svg_".concat(displayName);
    // Сделано для того, чтобы была возможность использовать имена в описании вложенных стилей. Если есть более элегантное решение, с радостью рассмотрим его ;-)
    return styled(SvgComponent)(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
};
var templateObject_1;
